exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width:40em){\n.row[data-v-0b635a42]{display:flex;flex-direction:row;justify-content:space-around\n}\n.title[data-v-0b635a42]{font-size:20px;font-weight:500;margin:50px 9px 12px\n}\n}", ""]);

// exports
